module.exports = __webpack_public_path__ + "img/457.002cb528.png";